module.exports = __webpack_public_path__ + "static/media/escaner-modo-almacen-cargar-datos.97469dc4.png";